var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-container"},[_c('insurance-payments',{ref:_vm.tableRef,attrs:{"fields":_vm.fields,"repository":_vm.repository,"resource":_vm.resource,"filterOn":{ byAttribute: { status_registry: 0 } },"filterName":_vm.filterName,"hasChecksButtonGroup":false},on:{"edit":_vm.onEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }